export const API_PROCESSING_RECORD = "/api/pre-ingest/processingRecord"
export const API_UPDATE_METADATA = "/api/pre-ingest/updateMetadata"
export const API_CLONE_RECORD = "/api/pre-ingest/cloneRecord"
export const API_PUBLISH_RECORD = "/api/pre-ingest/publishRecord"
export const API_ASSET_OFFERING = "/api/pre-ingest/assetOffering"
export const API_ERROR_EVENT = "/api/pre-ingest/errorEvent"
export const API_BILLING_ID = "/api/pre-ingest/billingId"
export const API_BILLING_ID_RANGE = "/api/pre-ingest/billingIdRange"
export const API_ASSIGN_BILLING_ID = "/api/pre-ingest/assignBillingId"



// WEBPACK FOOTER //
// ./src/PreIngest/urls.js